import { render, staticRenderFns } from "./CharactersSliderControls.vue?vue&type=template&id=465b3afe&"
import script from "./CharactersSliderControls.vue?vue&type=script&lang=js&"
export * from "./CharactersSliderControls.vue?vue&type=script&lang=js&"
import style0 from "./CharactersSliderControls.vue?vue&type=style&index=0&id=465b3afe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports